import React, { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";

import axios from "axiosConfig";
import { Helmet, HelmetProvider } from "react-helmet-async";

import "./BlogPages.css";

const Blog = () => {
  const { blogTitle } = useParams();

  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  //   const [resString, setResString] = useState("");
  const [content, setContent] = useState("");
  useEffect(() => {
    const fetchBlog = async () => {
      axios
        .get(`/blog/${blogTitle}/`)
        .then((res) => {
          console.log({ res: res.data });
          //   setResString(res.data);
          const parser = new DOMParser();
          const doc = parser.parseFromString(res.data, "text/html");

          // 2. Access the 'title' tag and the div with id 'content'
          const titleElement = doc.querySelector("title");
          const metaDescriptionElement = doc.querySelector("meta");
          const contentElement = doc.querySelector("body");
          //   console.log({ doc, titleElement, contentElement });

          // 3. Retrieve the text content of these elements
          const titleText = titleElement
            ? titleElement.textContent
            : "Not found";
          const metaText = metaDescriptionElement
            ? metaDescriptionElement.textContent
            : "Blog Not found";
          const contentHTML = contentElement ? contentElement.innerHTML : null;
          // console.log({ titleText, contentHTML });

          // Now 'titleText' contains the content of the 'title' tag, and 'contentText' contains the content of the div with id 'content'
          setTitle(titleText);
          setMetaDescription(metaText);
          setContent(contentHTML);
          // console.log("Title:", titleText);
          // console.log("Content:", contentHTML);
          // console.log({ res });
        })
        .catch((error) => {
          console.log({ error });
          setTitle("Not Found");
          setContent(null);
          setMetaDescription("Blog not found");
        })
        .finally(() => {
          setLoading(false);
        });
    };
    fetchBlog();
  }, []);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          {title && <title>{title}</title>}
          {metaDescription && (
            <meta name="description" content={metaDescription} />
          )}
        </Helmet>
      </HelmetProvider>

      <section id="blog-section">
        {loading ? (
          <h3 className="text-center">Loading...</h3>
        ) : (
          <Container className="mt-5">
            {content ? (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              <h2 className="text-center">Blog not found</h2>
            )}
          </Container>
        )}
      </section>
      {/* <p>{resString}</p> */}
    </>
  );
};
export default Blog;
